import { faqs } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于吃瓜在线，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed pl-10">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}